import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.js';
import Icon from '../Icon/Icon.js';
import styles from './RoundButton.module.scss.js';

var statuses = ['on', 'off'];
function RoundButton(_ref) {
  var icon = _ref.icon,
    status = _ref.status,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    error = _ref.error,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  var spinnerColor = status === 'on' || error ? 'white' : 'black';
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(styles.roundButton, styles[status], (disabled || isLoading) && styles.disabled, isLoading && styles.isLoading, error && styles.error, isSelected && styles.selected, className),
    id: dataTestId,
    onClick: onClick,
    disabled: disabled || isLoading
  }, isLoading && /*#__PURE__*/React.createElement(LoadingSpinner, {
    isLoading: isLoading,
    centered: true,
    color: spinnerColor,
    className: styles.spinner
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: "mediumplus"
  }));
}
RoundButton.propTypes = {
  icon: PropTypes.string.isRequired,
  status: PropTypes.oneOf(statuses),
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};
RoundButton.defaultProps = {
  status: 'off',
  disabled: false,
  className: '',
  isLoading: false,
  error: false,
  isSelected: false,
  onClick: function onClick() {},
  dataTestId: null
};

export { RoundButton as default };
